'use client';
import React, { createContext } from 'react';
import classnames from 'classnames';

const zendeskBase = 'https://assistenza.subito.it';
const secondHandEffectBase = 'https://www.subito.it/magazine/green/';
const infoJobsBase = 'https://www.infojobs.it';
const infoBase = 'https://info.subito.it';
const appleStore = 'https://itunes.apple.com/it/app/subito.it/id450775137?mt=8';
const shopBase = 'https://impresapiu.subito.it/';
const playStore = 'https://play.google.com/store/apps/details?id=it.subito&referrer=utm_source%3Dsite%26utm_medium%3Dfooter';
const subitoColumn1 = [
    {
        href: `${zendeskBase}/hc/it/`,
        label: 'Assistenza',
    },
    {
        href: `${zendeskBase}/hc/it/sections/10743588495133-Regole-di-pubblicazione`,
        label: 'Regole',
    },
    {
        href: `${zendeskBase}/hc/it/categories/10743145756317-Sicurezza`,
        label: 'Sicurezza',
    },
    {
        href: `${infoBase}/policies/condizioni-generali.htm`,
        label: 'Condizioni',
    },
    {
        href: `${infoBase}/policies/privacy.htm`,
        label: 'Privacy',
    },
    {
        label: 'Gestisci cookies',
        onClick: () => {
            Didomi.preferences.show('purposes');
        },
    },
    {
        href: `${infoBase}/tuttosubito.htm?utm_medium=autopromo&utm_source=subito&utm_campaign=free-attraction-lp_tuttosubito_seller&utm_content=autopromo_pmm_footer_info#vendi`,
        label: 'TuttoSubito Vendi',
    },
    {
        href: `${infoBase}/tuttosubito.htm?utm_medium=autopromo&utm_source=subito&utm_campaign=free-attraction-lp_tuttosubito_buyer&utm_content=autopromo_pmm_footer_info#compra`,
        label: 'TuttoSubito Compra',
    },
    {
        href: `${infoBase}/policies/tutto-subito.htm`,
        label: 'Servizio TuttoSubito',
    },
    {
        href: `${infoBase}/policies/tutto-subito-per-professionisti.htm`,
        label: 'Servizio TuttoSubito per Professionisti',
    },
    {
        href: 'https://www.subito.it/vendere/',
        label: 'Inserisci annuncio',
    },
    {
        href: `${infoBase}/policies/condizioni-promuovi.htm`,
        label: 'Promuovi annuncio',
    },
    {
        href: `${infoBase}/per-i-privati.htm`,
        label: 'Consigli per la vendita',
    },
    {
        href: `${shopBase}/shops?xtfrom=footer_menu`,
        label: 'Negozi e Aziende',
    },
    {
        href: 'https://aziende.subito.it/',
        label: 'Subito per le aziende',
    },
];
const subitoColumn2 = [
    {
        href: `${infoBase}/about.htm`,
        label: 'Chi siamo',
    },
    {
        href: `${infoBase}/lavora-con-noi.htm`,
        label: 'Lavora con noi',
    },
    {
        href: secondHandEffectBase,
        label: 'Sostenibilità',
        target: '_blank',
    },
    {
        href: 'https://www.subito.it/magazine/',
        label: 'Magazine',
        target: '_blank',
    },
    {
        href: 'https://info.subito.it/in-campo-con-le-tue-passioni-sportive.htm',
        label: 'Vivi lo Sport con Subito',
        target: '_blank',
    },
    {
        href: 'https://info.subito.it/idearegalo.htm',
        label: 'Idee regalo',
    },
    {
        href: infoJobsBase,
        label: 'InfoJobs',
        target: '_blank',
    },
    {
        href: 'https://www.subito.it/sitemaps/',
        label: 'Mappa del sito',
    },
];
const socialColumn = [
    {
        icon: 'social/facebook',
        href: 'https://it-it.facebook.com/subitoit',
        label: 'Facebook',
        target: '_blank',
    },
    {
        icon: 'social/tiktok',
        href: 'https://www.tiktok.com/@subito_it',
        label: 'TikTok',
        target: '_blank',
    },
    {
        icon: 'social/instagram',
        href: 'https://www.instagram.com/subito_it/',
        label: 'Instagram',
        target: '_blank',
    },
    {
        icon: 'social/youtube',
        href: 'https://www.youtube.it/user/subitoit',
        label: 'YouTube',
        target: '_blank',
    },
];
const appColumn = [
    {
        icon: 'app-stores/android',
        href: playStore,
        label: 'Subito per Android',
        target: '_blank',
    },
    {
        icon: 'app-stores/apple',
        href: appleStore,
        label: 'Subito per iOS',
        target: '_blank',
    },
];

var classes$2 = {"items__column":"Items-module_items__column__9Kbm0","items__column__title":"Items-module_items__column__title__LvV8X","list-link":"Items-module_list-link__dTOg5","list-link-wrapper":"Items-module_list-link-wrapper__ZJyvN","footer-icon":"Items-module_footer-icon__YjICl","footer-button":"Items-module_footer-button__92T2R"};

const initialValue = {};
const LinkContext = createContext(initialValue);

function Link(props) {
    const linkProp = React.useContext(LinkContext);
    const { children, ...anchorProps } = props;
    return (React.createElement("a", { ...anchorProps, href: anchorProps.href, onClick: (e) => {
            anchorProps.onClick?.(e);
            linkProp.onClick?.(anchorProps.href);
        } }, children));
}

const Items = (props) => (React.createElement("div", { className: classes$2['items__column'] },
    React.createElement("p", { className: classnames('body-text', 'semibold', 'small', classes$2['items__column__title']) }, props.title),
    React.createElement("ul", null, props.items.map((item) => (React.createElement("li", { key: item.label, className: classes$2['list-link-wrapper'] },
        item.icon ? (React.createElement("img", { src: `${props.assetsBase}/static/icons/${item.icon}.svg`, width: "16", height: "16", alt: "", className: classes$2['footer-icon'], crossOrigin: "anonymous", loading: "lazy" })) : null,
        'href' in item ? (React.createElement(Link, { href: item.href, target: item.target, className: classes$2['list-link'] },
            React.createElement("span", { className: "body-text small" }, item.label))) : (React.createElement("button", { onClick: item.onClick, className: classnames(classes$2['list-link'], classes$2['footer-button']) }, item.label))))))));

var classes$1 = {"bottom-links":"FooterLinks-module_bottom-links__0Rhpu"};

const FooterLinks = (props) => {
    if (props.show === 'full') {
        return (React.createElement("div", { className: classes$1['bottom-links'] },
            React.createElement(Items, { title: "Subito", items: subitoColumn1, assetsBase: props.assetsBase }),
            React.createElement(Items, { title: "", items: subitoColumn2, assetsBase: props.assetsBase }),
            React.createElement(Items, { title: "Seguici su", items: socialColumn, assetsBase: props.assetsBase }),
            React.createElement(Items, { title: "Scarica gratis l'App", items: appColumn, assetsBase: props.assetsBase })));
    }
    return React.createElement(React.Fragment, null);
};

var classes = {"footer-wrapper":"index-module_footer-wrapper__yvt-f","footer-bottom":"index-module_footer-bottom__Lg88q","footer-info":"index-module_footer-info__ARO6n"};

const Footer = (props) => {
    return (React.createElement(LinkContext.Provider, { value: { onClick: props.onClickItem } },
        React.createElement("footer", { className: classes['footer-wrapper'] },
            React.createElement(FooterLinks, { show: props.type, assetsBase: props.assetsBase }),
            React.createElement("div", { className: classes['footer-bottom'] },
                React.createElement("img", { src: `${props.assetsBase}/static/logos/grey-short.svg`, width: "136", height: "32", alt: "", crossOrigin: "anonymous", loading: "lazy" }),
                React.createElement("p", { className: classnames('body-text', 'small', classes['footer-info']) },
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " Subito.it - P.IVA 05526340962")))));
};
Footer.displayName = 'Footer';

export { Footer as default };
//# sourceMappingURL=index.js.map
